import fr from 'facet-rest';
import { buildPageLink } from 'Views/Page/Content/Templates';
import { clientPage, clientPaths } from 'Consts/Strings';
import { useNavContext } from 'Context/NavContext';
import { pathMatches } from 'Components/ClientApp/CombinedApp/Navigation/pathMatches';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const pathMatchesDashboard = pathMatches(clientPaths.dashboard);

export function useDashboardPath() {
  const { householdResource } = useSimpleHousehold();
  const { pageCollectionType } = useNavContext();

  return {
    dashboardPath: householdResource.withRelationship(
      fr.relationships.dashboard.name,
      (rel) => buildPageLink(rel.link('related'), clientPage),
      () => clientPaths.dashboard,
    ),
    dashboardSelectedIf({ location }) {
      return pageCollectionType === 'ClientDashboardPage' || pageCollectionType === 'clientDashboard' || pathMatchesDashboard({ location });
    },
  };
}
